import styled from 'styled-components';
import RSVG from 'react-svg';
export default styled(RSVG)<{
  src: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  &.relative-position {
    position: relative;
    left: -6px;
  }
`;
